import Label from 'types/Label';
import { Brand } from 'types/Brand';
import { Context } from 'types/Context';
import { KioskImages } from 'types/KioskImages';
import { AbstractMedia } from 'types/AbstractMedia';
import { KioskModel, KioskType } from 'types/KioskTypes';

import RefData from 'modules/refData/types/RefData';
import {
  ConfiguredWorkflows,
  CustomerType,
  PhoneNumber,
  SelfServiceOrigin,
  SelfServiceType
} from 'modules/selfServices/types/SelfService';
import { WhatsAppDetails } from '../../auth/types/LoginResponse';
import { ChannelEnum } from '../../auth/types/LoginRequest';

export enum KioskConnectionStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface ContextResponse extends Context {
  backgroundMedia?: AbstractMedia,
  brands: Brand[],
  confidentialityPolicyLink?: Label,
  legalNotice?:string;
  courtesyVehicleAvailabilityDate?: string,
  dealerCountry?: DealerCountry,
  id?: string,
  interventionLastMessageChannel?: ChannelEnum;
  isAvailable?: boolean,
  isEmergencyMode?: boolean,
  isPublic: boolean,
  isTokenExpired?: boolean,
  kioskBackgroundMedia: AbstractMedia,
  kioskConnectionStatus?: KioskConnectionStatus,
  kioskDealers? : Dealer[],
  kioskId? : string,
  kioskModel?: KioskModel,
  kioskImages?: KioskImages,
  kioskName? : string,
  kioskSpeech?: Label,
  kioskType?: KioskType,
  kioskTypes?: KioskType[],
  origin: SelfServiceOrigin,
  portraitBackgroundMedia?: AbstractMedia,
  refData?: RefData,
  registration?: string,
  customerType?: CustomerType,
  selfServiceAvailableTypes?: Partial<Record<SelfServiceType, SelfServiceOrigin[]>>,
  selfServiceKioskExplanationMedias?: AbstractMedia[],
  type?: SelfServiceType,
  theme?: string,
  kioskVideoGuide?: string;
  whatsApp: WhatsAppDetails;
}

export enum ConnectionTypeLogin {
  MFA = 'MFA',
  CODE = 'CODE',
  TOKEN = 'TOKEN',
}

export type ConnectionDetails = {
  type: ConnectionTypeLogin;
  methods: SelfOfficeLoginMethod[];
};


export enum SelfOfficeLoginMethod {
  CODE = 'CODE',
  PHONE_NUMBER = 'PHONE_NUMBER',
  QR_CODE = 'QR_CODE',
  REGISTRATION = 'REGISTRATION'
}

export interface Dealer {
  id: string,
  dealerName: string,
  dealerCustomerLanguage: string,
  confidentialityPolicyLink?: Label,
  generalTermsConditionsLink?: Label,
  selfServicePhoneNumber: PhoneNumber,
  selfServiceAvailableTypes: Partial<Record<SelfServiceType, SelfServiceOrigin[]>>,
  selfServiceKioskExplanationMedias?: AbstractMedia[],
  brands?: Brand[],
  dealerCountry?: DealerCountry,
  timezone?: string,
  workflows?: ConfiguredWorkflows,
  legalNotice?: string,
}

export interface DealerCountryLegal {
  requireConsentOnWithdrawalRights: boolean,
}

export interface DealerCountry {
  code: string,
  prefix: number,
  valueAddedTax: number,
  currency: string,
  currencyIsoCode: string,
  legal: DealerCountryLegal,
  senderIdAllowed: boolean,
  appCountry: boolean,
  name: string,
  timezones?: Record<string, string>,
}
